import React, { Component, createRef, RefObject } from "react";
import { connect } from "react-redux";
import { setTeamData } from "../../redux/slices/teamSlice";
import { Modal } from "react-bootstrap";
import ClanInvite from "../popup/ClanInvite";
import CaptainIcon from "../../images/icon/captain-ic.png";
import AddMember from "../popup/AddMember";
import AssignMember from "../popup/AssignMember";
import AcceptInviteV2 from "../popup/AcceptInviteV2";
import { toast } from "react-toastify";
import TeamApis from "../../helper/teams.api";
import "../../styles/TeamView.css";
import DefaultImage from "../../images/image 65.jpg";
import DefaultImageLoader from "../../images/Espotz-Banner.png";
import ShowMember from "../popup/ShowMember";
import ClanApis from "../../helper/clan.api";
import {
  ellipsis,
  errorHandler,
  defaultPreviewImage,
  capitalize,
  getMembersIds,
  getAllMembersIdFromTeam,
} from "../../utils/common.utils";
import { profile } from "../../utils/localstorage.utils";
import ConfirmationModal from "../popup/ConfirmationModal";
import { NavLink } from "react-router-dom";
import { IoArrowBackCircleOutline, IoPersonAdd } from "react-icons/io5";
import {
  AiOutlineSetting,
  AiFillPlusCircle,
  AiFillMinusCircle,
  AiFillCopyrightCircle,
  AiOutlineMinusCircle,
  AiFillCamera,
} from "react-icons/ai";
import Dropdown from "react-bootstrap/Dropdown";
import { IoIosCloseCircleOutline } from "react-icons/io";
import ImagePreview from "../common/ImagePreview";
import { BsCircle } from "react-icons/bs";
import leaveIcon from "../../images/icon/leave-ic.png";
import deleteIcon from "../../images/icon/delete-ic.png";
import participateIcon from "../../images/icon/participate-ic.png";
import lineupsIc from "../../images/icon/linups-ic.png";
import editInfoIc from "../../images/icon/edit-info-ic.png";
import instructionIcon from "../../images/icon/instruction-ic.png";
import { BiPlusMedical } from "react-icons/bi";
import {
  createAndSendNotification,
  removeOwnerOrAdminNotification,
} from "../../utils/notification.utils";
import Image from "../common/Image";
import CommonApis from "../../helper/common.api";

// Define types for props and state
interface TeamViewProps {
  match: {
    params: {
      id: string;
    };
    [key: string]: any;
  };
  showOrHideNav: (show: boolean) => void;
  updateLoader: (loading: boolean) => void;
  parentUpdate?: any;
  history: {
    push: (path: string) => void;
    [key: string]: any;
  };
  logout: () => void;
  joinTeamAfterCreation: (teamId: string, role: string, source: string) => void;
  [key: string]: any;
}

interface Member {
  id?: string;
  _id?: string;
  name?: string;
  inGameName?: string;
  profilePicture?: { url?: string };
  url?: string;
}

interface TeamData {
  _id?: string;
  name?: string;
  logo?: { url?: string };
  url?: string;
  gameDetails?: {
    name?: string;
    maxPlayersPerTeam?: number;
    url?: string;
  };
  members?: {
    captain?: Member | string;
    players?: (Member | string)[];
    substitutes?: (Member | string)[];
    coach?: (Member | string)[];
    manager?: (Member | string)[];
    [key: string]: any; // For dynamic access with string keys
  };
  clanId?: string;
  clanDetails?: any;
  [key: string]: any; // For any additional properties
}

interface ClanData {
  _id?: string;
  name?: string;
  coverImage?: {
    url?: string;
  };
  members?: {
    owner?: Member[];
    admin?: Member[];
    [key: string]: any;
  };
  [key: string]: any;
}

interface PreviewImageDetails {
  display: boolean;
  src: string;
}

interface ShowClanMember {
  members?: Member[];
  title?: string;
}

interface RemoveMember {
  id?: string;
  from?: string;
  name?: string;
  userId?: string;
}

interface Confirm {
  msg?: string;
  key?: string;
}

class TeamViewV2 extends Component<TeamViewProps, any> {
  multiselectRef: RefObject<any>;
  fileInputRef: React.RefObject<HTMLInputElement | null> =
    React.createRef<HTMLInputElement | null>();
  clanData: ClanData | null = null;
  teamMembers: string[];

  constructor(props: TeamViewProps) {
    super(props);
    this.teamMembers = ["players", "substitutes", "coach", "manager"];
    this.state = {
      teamView: 100,
      openClanInvite: false,
      openAcceptInvite: false,
      openAssignMember: false,
      openAddMember: false,
      openShowMember: false,
      teamApi: new TeamApis(),
      clanApi: new ClanApis(),
      commonApi: new CommonApis(),
      teamId: this.props.match.params.id,
      teamData: "",
      showClanMember: [],
      clanData: {},
      currentUserId: profile()?.id,
      currentUserTeamPosition: "",
      currentUserClanPosition: "",
      inviteAs: "",
      openConfirm: false,
      confirm: {},
      removeMember: {},
      selectedPlayers: [],
      selectedSubstitute: [],
      selectedCaptain: {},
      inGameInfo: {},
      participateInTeam: false,
      participantRole: this.teamMembers[0],
      multipleTeams: false,
      previewImageDetails: {
        display: false,
        src: defaultPreviewImage,
      },
      teamMembers: ["players", "substitutes", "coach", "manager"],
    };
    this.multiselectRef = createRef();
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id) {
      if (this.props.teamData && this.props.teamData._id === id) {
        this.setInitial(this.props.teamData);
        this.getClan(this.props.teamData.clanId);
        this.getMyTeams(this.props.teamData.clanId);
      } else {
        this.getData(id);
      }
    }
  }

  componentDidUpdate(prevProps: TeamViewProps) {
    if (
      this.props.teamData &&
      JSON.stringify(prevProps.teamData) !== JSON.stringify(this.props.teamData)
    ) {
      this.setInitial(this.props.teamData);
    }
  }

  confirmed = (key: string) => {
    const data = this.state.teamData;
    if (key === "remove") {
      const userData = {
        teamId: this.state.teamId,
        userId: this.state.removeMember?.id,
        role: this.state.removeMember.from,
      };
      this.removeMember(userData);
    } else if (key === "leave") {
      const index = data?.members[this.state.currentUserTeamPosition]
        ?.map((el: Member) => el.id)
        .indexOf(this.state.currentUserId);
      const teamMemberId = data?.members[this.state.currentUserTeamPosition][index]._id;
      const userData = {
        teamId: this.state.teamId,
        userId: teamMemberId,
      };
      this.leaveTeam(userData);
    } else if (key === "delete") {
      this.deleteTeam();
    }
    this.setState({
      openConfirm: !this.state.openConfirm,
    });
  };

  removeMsg = (position: string, name: string) => {
    return (
      <p className="fs-14 fw-600 text-center text-white-50">
        Are you sure you want to remove {name} from the team {position} position?
      </p>
    );
  };

  leaveMsg = () => {
    return this.state.currentUserClanPosition === "owner" ||
      this.state.currentUserClanPosition === "admin" ? (
      <p className="fs-14 fw-600 text-center text-white-50">
        Are you sure you want to leave this team?
      </p>
    ) : this.state.multipleTeams ? (
      <p className="fs-14 fw-600 text-center text-white-50">
        Are you sure you want to leave this team?
      </p>
    ) : (
      <p className="fs-14 fw-600 text-center text-white-50">
        {" "}
        By leaving this team, you are leaving the clan as well. Are you sure you want to leave the
        team?
      </p>
    );
  };

  teamDeleteMsg = () => {
    return (
      <p className="fs-14 fw-600 text-center text-white-50">
        {" "}
        <span className="error-msg">
          Upon deletion of the team, every member will be removed from the team.
          <br />
          The team will no longer exist, so no Espotz tournaments can be registered by using this
          team anymore.{" "}
        </span>{" "}
        Are you sure you want to <span className="error-msg">delete</span> the team?
      </p>
    );
  };

  onClickOpenConfirm = (key: string, msg: any) => {
    const data = {
      msg: msg ? msg : "",
      key: key ? key : "",
    };
    this.setState({
      openConfirm: !this.state.openConfirm,
      confirm: data,
    });
  };

  setRemoveData(user: Member, id: string, from: string, name: string) {
    const data = {
      id: id,
      from: from,
      name: name,
      userId: user?.id,
    };
    this.setState({ removeMember: data });
  }

  deleteTeam() {
    this.props.updateLoader(true);
    this.state.teamApi
      .deleteTeam(this.state.teamId)
      .then((res: any) => {
        this.props.updateLoader(false);
        toast.success("Team deleted successfully");
        this.sendNotifications("Delete");
        this.props.history.push(`/clan/view/${this.state.teamData.clanId}`);
      })
      .catch((err: any) => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  }

  sendNotifications = (action: string, sendTo?: string[]) => {
    let to;
    if (sendTo) {
      to = sendTo;
    } else {
      to = getAllMembersIdFromTeam(this.state?.teamData?.members);
    }
    let data: any;
    switch (action) {
      case "Delete":
        data = {
          type: "TEAM",
          heading: "Team Deleted 🗑️ :",
          message: `Your team '${this.state?.teamData?.name}' of clan '${this.state?.clanData?.name}' has been deleted by ${profile().name}.`,
          link: null,
        };
        break;
      case "Captain":
        data = {
          type: "TEAM",
          heading: "Team Shuffled 🔀 :",
          message: `Your team '${this.state?.teamData?.name}' has been re-shuffled by ${profile().name} and now you are the Captain of this team.`,
          link: `/clan/team/view/${this.state?.teamData?._id}`,
        };
        break;
      case "Player":
        data = {
          type: "TEAM",
          heading: "Team Shuffled 🔀 :",
          message: `Your team '${this.state?.teamData?.name}' has been re-shuffled by ${profile().name} and now you are the Player of this team.`,
          link: `/clan/team/view/${this.state?.teamData?._id}`,
        };
        break;
      case "Substitute":
        data = {
          type: "TEAM",
          heading: "Team Shuffled 🔀 :",
          message: `Your team '${this.state?.teamData?.name}' has been re-shuffled by ${profile().name} and now you are the Substitute of this team.`,
          link: `/clan/team/view/${this.state?.teamData?._id}`,
        };
        break;
      default:
        break;
    }
    createAndSendNotification(data, to);
  };

  removeFromPlayers = (el: Member, i: number) => {
    if (this.state.selectedSubstitute.length >= 3) {
      toast.error("Team Cannot Have more than 3 substitute");
      return false;
    } else {
      const data = this.state.selectedSubstitute;
      const removeData = this.state.selectedPlayers;
      data.push(el);
      removeData.splice(i, 1);
      this.setState({
        selectedSubstitute: data,
        selectedPlayers: removeData,
      });
      if (el?._id === this.state.selectedCaptain?._id && removeData?.length) {
        this.setState({ selectedCaptain: removeData[0] });
      }
      if (!removeData?.length) {
        this.setState({ selectedCaptain: null });
      }
    }
  };

  removeFromSubstitute = (el: Member, i: number) => {
    const data = this.state.selectedPlayers;
    const removeData = this.state.selectedSubstitute;
    data.push(el);
    removeData.splice(i, 1);
    this.setState({
      selectedSubstitute: removeData,
      selectedPlayers: data,
    });
    if (data?.length === 1) {
      this.setState({ selectedCaptain: data[0] });
    }
  };

  makeCaptain = (el: Member) => {
    this.setState({
      selectedCaptain: el,
    });
  };

  enableSetting = () => {
    if (this.state.teamView === 100) {
      this.setState({ teamView: 101 });
    } else {
      this.setState({ teamView: 100 });
    }
  };

  getData = (id: string) => {
    const data = {
      _id: id,
    };
    this.props.updateLoader(true);
    this.state.teamApi
      .getTeams(data)
      .then((res: any) => {
        if (res.data["result"]?.length === 0) {
          this.props.history.push(`/clans`);
          return;
        }
        const teamData = res.data["result"][0];
        this.props.setTeamData(teamData);
        this.getClan(teamData.clanId);
        this.getMyTeams(teamData.clanId);
        this.setInitial(teamData);
        this.props.updateLoader(false);
      })
      .catch((err: any) => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  getMyTeams = (id: string) => {
    const data = {
      clanId: id,
    };
    this.props.updateLoader(true);
    this.state.teamApi
      .getMyTeams(data)
      .then((res: any) => {
        if (res.data.result.length > 1) {
          this.setState({
            multipleTeams: true,
          });
        }
        if (res.data.result.length > 0) {
          if (
            this.state.teamId &&
            res.data.result.some((team: any) => team._id === this.state.teamId)
          ) {
            const currentTeam = res.data.result.find((team: any) => team._id === this.state.teamId);
            if (currentTeam) {
              this.props.setTeamData(currentTeam);
            }
          }
        }
        this.props.updateLoader(false);
      })
      .catch((err: any) => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  setInitial = (data: TeamData) => {
    this.setState({
      teamData: data,
      teamView: 100,
    });

    // Helper function to get member ID from either string or Member object
    const getMemberId = (member: string | Member): string | undefined => {
      return typeof member === "string" ? member : member?.id;
    };

    // Helper function to check if member is in the array
    const isMemberInArray = (arr: (string | Member)[], userId: string): boolean => {
      if (!arr) return false;
      return arr.some(member => getMemberId(member) === userId);
    };

    // Set current user's team position
    if (isMemberInArray(data?.members?.players || [], this.state.currentUserId)) {
      this.setState({ currentUserTeamPosition: "players" });
    } else if (isMemberInArray(data?.members?.substitutes || [], this.state.currentUserId)) {
      this.setState({ currentUserTeamPosition: "substitutes" });
    } else if (isMemberInArray(data?.members?.coach || [], this.state.currentUserId)) {
      this.setState({ currentUserTeamPosition: "coach" });
    } else if (isMemberInArray(data?.members?.manager || [], this.state.currentUserId)) {
      this.setState({ currentUserTeamPosition: "manager" });
    }

    // Process players and substitutes
    const selectedPlayers: Member[] = [];
    const selectedSubstitutes: Member[] = [];

    data?.members?.players?.forEach(member => {
      if (typeof member !== "string") {
        selectedPlayers.push(member);
      }
    });

    data?.members?.substitutes?.forEach(member => {
      if (typeof member !== "string") {
        selectedSubstitutes.push(member);
      }
    });

    this.setState({
      selectedCaptain:
        typeof data?.members?.captain === "string" ? undefined : data?.members?.captain,
      selectedPlayers,
      selectedSubstitute: selectedSubstitutes,
    });

    // Set inGameInfo for current user
    if (data?.members && this.state.currentUserTeamPosition) {
      const membersArray = data.members[this.state.currentUserTeamPosition];
      if (Array.isArray(membersArray)) {
        const member = membersArray.find(m => {
          const memberId = typeof m === "string" ? m : m?.id;
          return memberId === this.state.currentUserId;
        });

        if (member && typeof member !== "string") {
          this.setState({
            inGameInfo: member,
          });
        }
      }
    }
  };

  teamShuffle = () => {
    if (this.state.selectedSubstitute.length > 3) {
      toast.error("Team Cannot Have more than 3 substitute");
      return false;
    }
    if (this.state.selectedPlayers.length === 0) {
      this.setState({ selectedCaptain: {} });
    }
    if (this.state.selectedPlayers.length > this.state.teamData?.gameDetails?.maxPlayersPerTeam) {
      toast.error(
        `Team Cannot Have more than ${this.state.teamData?.gameDetails?.maxPlayersPerTeam} players`
      );
      return false;
    } else {
      const updatedTeamData = {
        ...this.state.teamData,
        members: {
          ...this.state.teamData.members,
          captain: this.state.selectedCaptain,
          players: this.state.selectedPlayers,
          substitutes: this.state.selectedSubstitute,
        },
      };

      this.setState({ teamData: updatedTeamData }, () => {
        this.updateTeam("Team reassigned successfully", 544);
      });
    }
  };

  getClan(id: string) {
    const data = {
      _id: id,
    };
    this.props.updateLoader(true);
    this.state.clanApi
      .getClans(data)
      .then((res: any) => {
        const data = res.data["result"][0];
        this.setState({ clanData: data });
        if (
          data?.members?.owner &&
          data?.members?.owner?.map((el: Member) => el?.id).includes(this.state.currentUserId)
        ) {
          this.setState({ currentUserClanPosition: "owner" });
        } else if (
          data?.members?.admin &&
          data?.members?.admin?.map((el: Member) => el?.id).includes(this.state.currentUserId)
        ) {
          this.setState({ currentUserClanPosition: "admin" });
        }
        this.props.updateLoader(false);
      })
      .catch((err: any) => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  }

  onClickOpenShowMember = (members: Member[], title: string) => {
    const data = {
      members: members ? members : "",
      title: title ? title : "",
    };
    this.setState({
      openShowMember: !this.state.openShowMember,
      showClanMember: data,
    });
  };

  toggelModal = (key: string) => {
    this.setState({
      [key]: !this.state[key],
    });
  };

  bioChange = (data: any) => {
    this.setState({
      inGameInfo: data,
      openAcceptInvite: false,
    });
  };

  removeMember = (data: any) => {
    this.props.updateLoader(true);
    this.state.teamApi
      .removeTeamMember(data)
      .then((res: any) => {
        removeOwnerOrAdminNotification(
          "team",
          this.state?.teamData,
          this.state.removeMember?.userId,
          this.state.removeMember?.from
        );
        this.setInitial(res.data.result);
        const wasSelf = this.state.removeMember?.userId === this.state.currentUserId;
        if (wasSelf) {
          this.setState({
            currentUserTeamPosition: "",
            inGameInfo: {},
          });
        }
        this.props.updateLoader(false);
        toast.success(`${this.state.removeMember?.name} Removed Successfully`);
      })
      .catch((err: any) => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  leaveTeam = (data: any) => {
    this.props.updateLoader(true);
    this.state.teamApi
      .leaveTeam(data)
      .then((res: any) => {
        this.props.updateLoader(false);
        toast.success("Team Left Successfully");
        this.props.setTeamData(null);
        if (
          this.state.currentUserClanPosition === "owner" ||
          this.state.currentUserClanPosition === "admin"
        ) {
          this.props.history.push(`/clan/view/${this.state.teamData.clanId}`);
        } else if (this.state.multipleTeams) {
          this.props.history.push(`/clan/view/${this.state.teamData.clanId}`);
        } else {
          this.props.history.push(`/clans`);
        }
      })
      .catch((err: any) => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  updateTeam(updateMsg: string, type?: number) {
    const data = JSON.parse(JSON.stringify(this.state.teamData));
    delete data.gameDetails;
    delete data.clanDetails;
    data.members = {
      ...data.members,
      captain: data.members?.captain?._id || data.members?.captain,
      players: data.members?.players?.map((el: Member) => el?._id || el) || [],
      substitutes: data.members?.substitutes?.map((el: Member) => el?._id || el) || [],
    };
    if (data.members.manager && data.members.manager.length) {
      data.members.manager = data.members.manager.map((el: Member) => el?._id || el);
    }
    if (data.members.coach && data.members.coach.length) {
      data.members.coach = data.members.coach.map((el: Member) => el?._id || el);
    }
    this.props.updateLoader(true);
    this.state.teamApi
      .updateTeam(this.state.teamId, data)
      .then((res: any) => {
        const data = res.data["result"];
        if (type === 544) {
          this.sendNotificationsAfterShuffle(this.state);
          this.setState({
            selectedPlayers: [],
            selectedSubstitutes: [],
            selectedCaptain: {},
          });
        }
        this.getData(data._id);
        this.props.updateLoader(false);
        toast.success(updateMsg);
      })
      .catch((err: any) => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  }

  sendNotificationsAfterShuffle = (state: any) => {
    const { selectedCaptain, selectedSubstitute, selectedPlayers } = state;
    const players: string[] = [];
    const substitutes: string[] = [];
    selectedPlayers.forEach((player: Member) => {
      if (player.id !== selectedCaptain.id) {
        players.push(player.id!);
      }
    });
    selectedSubstitute.forEach((substitute: Member) => {
      substitutes.push(substitute.id!);
    });
    this.sendNotifications("Captain", [selectedCaptain.id]);
    this.sendNotifications("Player", players);
    this.sendNotifications("Substitute", substitutes);
  };

  participateInTeam = (param: boolean) => {
    this.setState({
      participateInTeam: param,
      participantRole: param ? this.state.participantRole : this.teamMembers[0],
    });
  };

  joinTeam = () => {
    this.participateInTeam(false);
    this.props.joinTeamAfterCreation(
      this.state.teamData._id,
      this.state.participantRole,
      "Team Profile"
    );
  };

  previewImage = (src: string, param: boolean) => {
    this.setState({
      previewImageDetails: {
        display: param,
        src: param ? src : defaultPreviewImage,
      },
    });
  };

  removeFromCaptain = () => {
    //console.log('Remove Captain Called');
  };

  addImg = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const img = event.target.files[0];
      if (!img.name.match(/\.(jpg|jpeg|png)$/)) {
        toast.warning("Please select a valid image type.");
        return false;
      }

      const teamData = { ...this.state.teamData };
      if (!teamData.logo) {
        teamData.logo = {};
      }
      teamData.logo = {
        ...teamData.logo,
        url: URL.createObjectURL(img),
      };

      this.setState({ teamData });

      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      this.props.updateLoader(true);
      this.state.commonApi
        .uploadSingleImg(formData)
        .then((response: any) => {
          // Create new object references for the updated logo URL
          const updatedTeamData = {
            ...this.state.teamData,
            logo: {
              ...this.state.teamData.logo,
              url: response.data.result.url,
            },
          };

          this.setState({ teamData: updatedTeamData }, () => {
            this.updateTeam("Team logo updated successfully");
            this.props.updateLoader(false);
          });
        })
        .catch((err: any) => {
          this.props.updateLoader(false);
          errorHandler(err, this.props.logout);
        });
    }
  };

  openFileInput = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  triggerInputFile = () => {
    if (
      this.state.currentUserClanPosition === "owner" ||
      this.state.currentUserClanPosition === "admin"
    ) {
      this.openFileInput();
    } else {
      toast.warning("Only Clan owner/admin can perform this action");
    }
  };

  render() {
    const { openAddMember, openAssignMember, openClanInvite, openAcceptInvite, openShowMember } =
      this.state;
    return (
      <>
        <section className="body-section team-view-page">
          <div className="teamView-banner">
            <img
              className="clanView-background"
              src={
                this.state.clanData?.coverImage?.url
                  ? this.state?.clanData?.coverImage?.url
                  : DefaultImageLoader
              }
              width="50"
              height="50"
              alt=""
            />

            <img
              className="clanView-fronImage"
              src={
                this.state.clanData?.coverImage?.url
                  ? this.state?.clanData?.coverImage?.url
                  : DefaultImageLoader
              }
              onClick={() =>
                this.previewImage(
                  this.state.clanData?.coverImage?.url
                    ? this.state?.clanData?.coverImage?.url
                    : DefaultImageLoader,
                  true
                )
              }
              width="50"
              height="50"
              alt=""
            />

            <div className="team-name position-absolute w-100">
              <h1
                className=" fs-12 fw-500 text-white-50 border border-1 float-end me-2 rounded-10 py-1 py-md-1 py-lg-2 px-2 px-md-3 px-lg-4"
                style={{ background: "#353550" }}
              >
                {this.state.teamData?.gameDetails?.name}
              </h1>
            </div>
          </div>

          {this.state.teamView === 100 && (
            <div className="container teamView-section ps-4 pe-4">
              <NavLink to={`/clan/view/${this.state.clanData?._id}`}>
                <IoArrowBackCircleOutline className="back-btn" />
              </NavLink>

              <div
                className="row d-flex flex-row position-relative"
                style={{ alignItems: "flex-end", marginTop: "-50px" }}
              >
                <div className="col-lg-2 col-3 position-relative">
                  <Image
                    src={this.state?.teamData?.logo?.url}
                    param={
                      this.state?.teamData?.logo?.url
                        ? null
                        : this.state?.teamData?.name?.split(" ")[0]
                    }
                    className="team-logo rounded-circle border border-1 border-white"
                    height="148px"
                    width="148px"
                  />
                </div>

                <div className="col-lg-9 col-7">
                  <h6 className="fs-20 fs-lg-24 fw-600 text-white mb-0 ms-4 text-truncate">
                    <span className="fs-12 fs-lg-16 fw-600 text-white-50">Welcome to </span> <br />
                    {this.state?.teamData?.name?.substring(0, 25)}
                    {this.state?.teamData?.name?.length > 25 ? "..." : null}
                  </h6>
                </div>
                <div className="col-lg-1 col-2">
                  <button
                    type="button"
                    className="white-round-btn rounded-circle fw-600 border border-0 btn-size-32 float-end"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.enableSetting}
                  >
                    <AiOutlineSetting className="btn-size-20" />
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="row my-3">
                    <div className="col-lg-6 offset-lg-3 col-md-12 col-12 text-center">
                      <h6 className="fw-600 fs-16">
                        <img src={CaptainIcon} className="btn-size-20 pb-1" alt="" /> Team Captain
                      </h6>
                    </div>
                    {this.state.teamData?.members?.captain ? (
                      <div className="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-12 mb-2">
                        <div className="husk-gradient-card d-flex align-items-center py-2">
                          <div className="col-3">
                            <Image
                              src={this.state?.teamData?.members?.captain?.profilePicture?.url}
                              param={
                                this.state?.teamData?.members?.captain?.profilePicture?.url
                                  ? null
                                  : this.state.teamData?.members?.captain?.inGameName?.charAt(0)
                              }
                              className="rounded-circle btn-size-25 border border-1 d-block m-auto"
                              height="32px"
                              width="32px"
                            />
                          </div>
                          <div className="col-6">
                            <div className="fs-16 fw-500 text-white text-start text-truncate">
                              {this.state.teamData?.members?.captain?.inGameName}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          this.toggelModal("openClanInvite");
                          this.setState({ inviteAs: "captain" });
                        }}
                        className="col-lg-4 offset-lg-4 cursor-pointer"
                      >
                        <button
                          disabled={!this.state.clanData?.isActive}
                          className="black-flat-btn p-2 text-center mb-0 w-100 rounded-10 cursor-pointer border-0 text-white"
                        >
                          <AiFillPlusCircle className="fs-24 cursor-pointer" />
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-12">
                  <div className="row mt-4 justify-content-lg-center">
                    <div className="col-12 d-flex justify-content-between mb-2 align-items-center">
                      <h6 className="fs-20 fw-600 text-white mb-0">Team Members</h6>
                      {(this.state.currentUserClanPosition === "owner" ||
                        this.state.currentUserClanPosition === "admin" ||
                        this.state.currentUserTeamPosition === "players") && (
                        <button
                          type="button"
                          className="white-round-btn rounded-circle fw-600 border border-0 btn-size-32"
                          onClick={() => {
                            this.toggelModal("openClanInvite");
                            this.setState({ inviteAs: "players" });
                          }}
                        >
                          <BiPlusMedical className="text-black" />
                        </button>
                      )}
                    </div>
                    {/* Players */}
                    {this.state.teamData?.members?.players?.length !== 0 ? (
                      this.state.teamData?.members?.players?.map((el: any, i: any) => {
                        return (
                          <div className="col-lg-2 col-md-2 col-4 mb-4" key={i}>
                            <div
                              className={` ${this.state.teamData?.members?.captain?.id === el?.id ? "husk-gradient-card" : "member-card"} showAddMember-body pt-2`}
                            >
                              {(this.state.currentUserClanPosition === "owner" ||
                                this.state.currentUserClanPosition === "admin") && (
                                <button
                                  type="button"
                                  className="bg-transparent border-0 position-absolute p-0 text-white d-flex"
                                  style={{ marginTop: "-15px", marginLeft: "85px" }}
                                  data-dismiss="modal"
                                  aria-label="Close"
                                  onClick={() => {
                                    this.onClickOpenConfirm(
                                      "remove",
                                      this.removeMsg("players", el?.inGameName)
                                    );
                                    this.setRemoveData(el, el?._id, "players", el?.inGameName);
                                  }}
                                >
                                  <AiFillMinusCircle className="fs-20" />
                                </button>
                              )}

                              <Image
                                src={el?.profilePicture?.url}
                                param={el?.profilePicture?.url ? null : el?.name?.charAt(0)}
                                className="btn-size-32 border-1 border-dark rounded-circle my-1"
                              />
                              <div className="fs-10 text-white mt-1 fw-500">
                                {ellipsis(el?.inGameName, 12)}
                              </div>
                              {this.state.teamData?.members?.captain?.id === el?.id && (
                                <div className="fs-10 text-white fw-500 mt-1">
                                  <span className="text-warning d-flex justify-content-center">
                                    Captain
                                    {el?.id === this.state.currentUserId && (
                                      <div className="fs-10 text-white fw-500 ms-1">(you)</div>
                                    )}
                                  </span>
                                </div>
                              )}

                              {this.state.teamData?.members?.captain?.id !== el?.id &&
                                el?.id !== this.state.currentUserId && (
                                  <div className="fs-10 text-white mt-1 fw-500">
                                    Member
                                    {el?.id === this.state.currentUserId && (
                                      <div className="fs-10 text-white fw-500 ms-1">(you)</div>
                                    )}
                                  </div>
                                )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-lg-2 col-md-2 col-4 mb-4">
                        <div className="no-member-card showAddMember-body d-flex align-items-center justify-content-center">
                          <div className="fs-12 fw-600 text-white-50">No Member</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* Substitutes */}
                <div className="col-12">
                  <div className="row justify-content-lg-center">
                    <div className="col-12 d-flex justify-content-between mb-2 align-items-center">
                      <h6 className="fs-20 fw-600 text-white mb-0">Substitutes</h6>
                      {(this.state.currentUserClanPosition === "owner" ||
                        this.state.currentUserClanPosition === "admin") && (
                        <button
                          type="button"
                          className="white-round-btn rounded-circle fw-600 border border-0 btn-size-32"
                          onClick={() => {
                            if (this.state.teamData.members?.substitutes?.length >= 3) {
                              toast.warning("You can only add maximum 3 substitutes.");
                            } else {
                              this.toggelModal("openClanInvite");
                              this.setState({ inviteAs: "substitutes" });
                            }
                          }}
                        >
                          <BiPlusMedical className="text-black" />
                        </button>
                      )}
                    </div>

                    {this.state.teamData?.members?.substitutes &&
                    this.state.teamData?.members?.substitutes?.length !== 0 ? (
                      this.state.teamData?.members?.substitutes?.map((el: any, i: any) => {
                        return (
                          <div className="col-lg-2 col-md-2 col-4 mb-4" key={i}>
                            <div className="substitute-card showAddMember-body pt-2">
                              {(this.state.currentUserClanPosition === "owner" ||
                                this.state.currentUserClanPosition === "admin") && (
                                <button
                                  type="button"
                                  className="bg-transparent border-0 position-absolute p-0 text-white d-flex"
                                  style={{ marginTop: "-15px", marginLeft: "85px" }}
                                  data-dismiss="modal"
                                  aria-label="Close"
                                  onClick={() => {
                                    this.onClickOpenConfirm(
                                      "remove",
                                      this.removeMsg("substitutes", el?.inGameName)
                                    );
                                    this.setRemoveData(el, el?._id, "substitutes", el?.inGameName);
                                  }}
                                >
                                  <AiFillMinusCircle className="fs-20" />
                                </button>
                              )}
                              <Image
                                src={el?.profilePicture?.url}
                                param={el?.profilePicture?.url ? null : el?.name?.charAt(0)}
                                className="btn-size-32 border-1 border-dark rounded-circle my-1"
                              />
                              <div className="fs-10 text-white mt-1 fw-500">
                                {ellipsis(el?.inGameName, 12)}
                              </div>
                              <div className="fs-10 text-white mt-1 fw-500">Substitute</div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-lg-2 col-md-2 col-4 mb-4">
                        <div className="no-member-card showAddMember-body d-flex align-items-center justify-content-center">
                          <div className="fs-12 fw-600 text-white-50 p-2">No Substitutes</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-12">
                  <div className="row justify-content-lg-center">
                    <div className="col-12 d-flex justify-content-between mb-2 align-items-center">
                      <h6 className="fs-20 fw-600 text-white mb-0">Coach</h6>
                      {(this.state.currentUserClanPosition === "owner" ||
                        this.state.currentUserClanPosition === "admin") && (
                        <button
                          type="button"
                          className="white-round-btn rounded-circle fw-600 border border-0 btn-size-32"
                          onClick={() => {
                            if (this.state.teamData?.members?.coach?.length >= 3) {
                              toast.warning("You can only add maximum 3 coaches.");
                            } else {
                              this.toggelModal("openClanInvite");
                              this.setState({ inviteAs: "coach" });
                            }
                          }}
                        >
                          <BiPlusMedical className="text-black" />
                        </button>
                      )}
                    </div>

                    {this.state.teamData?.members?.coach &&
                    this.state.teamData?.members?.coach?.length !== 0 ? (
                      this.state.teamData?.members?.coach?.map((el: any, i: any) => {
                        return (
                          <div className="col-lg-2 col-md-2 col-4 mb-4" key={i}>
                            <div className="coach-card showAddMember-body pt-2">
                              {(this.state.currentUserClanPosition === "owner" ||
                                this.state.currentUserClanPosition === "admin") && (
                                <button
                                  type="button"
                                  className="bg-transparent border-0 position-absolute p-0 text-white d-flex"
                                  style={{ marginTop: "-15px", marginLeft: "85px" }}
                                  data-dismiss="modal"
                                  aria-label="Close"
                                  onClick={() => {
                                    this.onClickOpenConfirm(
                                      "remove",
                                      this.removeMsg("coach", el?.inGameName)
                                    );
                                    this.setRemoveData(el, el?._id, "coach", el?.inGameName);
                                  }}
                                >
                                  <AiFillMinusCircle className="fs-20" />
                                </button>
                              )}
                              <Image
                                src={el?.profilePicture?.url}
                                param={el?.profilePicture?.url ? null : el?.name?.charAt(0)}
                                className="btn-size-32 border-1 border-dark rounded-circle my-1"
                              />{" "}
                              <div className="fs-10 text-white mt-1 fw-500">
                                {ellipsis(el?.inGameName, 12)}
                              </div>
                              <div className="fs-10 text-white mt-1 fw-500">
                                {" "}
                                <span className="text-success">Coach</span>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-lg-2 col-md-2 col-4 mb-4">
                        <div className="no-member-card showAddMember-body d-flex align-items-center justify-content-center">
                          <div className="fs-12 fw-600 text-white-50">No Coach</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-12">
                  <div className="row mb-4 justify-content-lg-center">
                    <div className="col-12 d-flex justify-content-between mb-2 align-items-center">
                      <h6 className="fs-20 fw-600 text-white mb-0">Managers</h6>
                      {(this.state.currentUserClanPosition === "owner" ||
                        this.state.currentUserClanPosition === "admin") && (
                        <button
                          type="button"
                          className="white-round-btn rounded-circle fw-600 border border-0 btn-size-32"
                          onClick={() => {
                            if (this.state.teamData?.members?.manager?.length >= 3) {
                              toast.warning("You can only add maximum 3 managers.");
                            } else {
                              this.toggelModal("openClanInvite");
                              this.setState({ inviteAs: "manager" });
                            }
                          }}
                        >
                          <BiPlusMedical className="text-black" />
                        </button>
                      )}
                    </div>

                    {this.state.teamData?.members?.manager &&
                    this.state.teamData?.members?.manager?.length !== 0 ? (
                      this.state.teamData?.members?.manager?.map((el: any, i: any) => {
                        return (
                          <div className="col-lg-2 col-md-2 col-4 mb-4" key={i}>
                            <div className="manager-card showAddMember-body pt-2">
                              {(this.state.currentUserClanPosition === "owner" ||
                                this.state.currentUserClanPosition === "admin") && (
                                <button
                                  type="button"
                                  className="bg-transparent border-0 position-absolute p-0 text-white d-flex"
                                  style={{ marginTop: "-15px", marginLeft: "85px" }}
                                  data-dismiss="modal"
                                  aria-label="Close"
                                  onClick={() => {
                                    this.onClickOpenConfirm(
                                      "remove",
                                      this.removeMsg("manager", el?.inGameName)
                                    );
                                    this.setRemoveData(el, el?._id, "manager", el?.inGameName);
                                  }}
                                >
                                  <AiFillMinusCircle className="fs-20" />
                                </button>
                              )}
                              <Image
                                src={el?.profilePicture?.url}
                                param={el?.profilePicture?.url ? null : el?.name?.charAt(0)}
                                className="btn-size-32 border-1 border-dark rounded-circle my-1"
                              />
                              <div className="fs-10 text-white mt-1 fw-500">
                                {ellipsis(el?.inGameName, 12)}
                              </div>
                              <div className="fs-10 text-white mt-1 fw-500">Manager</div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-lg-2 col-md-2 col-4 ">
                        <div className="no-member-card showAddMember-body d-flex align-items-center justify-content-center">
                          <div className="fs-12 fw-600 text-white-50 p-2">No Manager</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.state.teamView === 101 && (
            <div className="container setting-section ps-4 pe-4">
              <IoArrowBackCircleOutline className="back-btn" onClick={this.enableSetting} />

              <div
                className="row d-flex flex-row position-relative"
                style={{ alignItems: "flex-end", marginTop: "-50px" }}
              >
                <div className="col-lg-2 col-3 position-relative">
                  <img
                    src={
                      this.state.teamData?.logo?.url
                        ? this.state?.teamData?.logo?.url
                        : DefaultImageLoader
                    }
                    onClick={() =>
                      this.previewImage(
                        this.state.teamData?.logo?.url
                          ? this.state?.teamData?.logo?.url
                          : DefaultImageLoader,
                        true
                      )
                    }
                    alt="clan logo"
                    className="team-logo rounded-circle border border-1 border-white"
                  />

                  {/* Add input and camera icon for team image change in settings view */}
                  <input
                    type="file"
                    id="upload_file_settings"
                    accept=".png, .jpg, .jpeg"
                    hidden
                    onChange={this.addImg}
                    ref={this.fileInputRef}
                    name=""
                    className="profile-picker"
                  />
                  <div
                    className="cam-container bg-white position-absolute btn-size-25 rounded-circle d-flex align-items-center justify-content-center"
                    style={{ bottom: "10px", right: "10px" }}
                  >
                    <AiFillCamera
                      className="text-dark"
                      id="upload_file_settings"
                      onClick={this.triggerInputFile}
                    />
                  </div>
                </div>

                <div className="col-lg-10 col-9">
                  <h6 className="fs-20 fs-lg-24 fw-600 text-white mb-0 ms-4 text-truncate">
                    <span className="fs-12 fs-lg-16 fw-600 text-white-50 ">Welcome to </span> <br />
                    {this.state?.teamData?.name?.substring(0, 25)}
                    {this.state?.teamData?.name?.length > 25 ? "..." : null}
                  </h6>
                </div>
              </div>

              <div className="row d-flex justify-content-center pt-4">
                {this.state.teamMembers.includes(this.state.currentUserTeamPosition) ? (
                  <div className="col-lg-2 col-md-2 col-4 text-center mb-3">
                    <button
                      className="white-round-btn rounded-circle fw-600 border border-0 btn-size-45"
                      onClick={() => {
                        this.onClickOpenConfirm("leave", this.leaveMsg());
                      }}
                    >
                      <img src={leaveIcon} style={{ height: "20px" }} alt="" />
                    </button>
                    <p className="fs-12 fw-bold text-white mt-2 mb-0">Leave Team</p>
                  </div>
                ) : null}

                {this.state.teamMembers.includes(this.state.currentUserTeamPosition)
                  ? null
                  : (this.state.currentUserClanPosition === "owner" ||
                      this.state.currentUserClanPosition === "admin") && (
                      <div className="col-lg-2 col-md-2 col-4 text-center mb-3">
                        <button
                          className="white-round-btn rounded-circle fw-600 border border-0 btn-size-45"
                          onClick={() => {
                            this.participateInTeam(true);
                          }}
                        >
                          <img src={participateIcon} style={{ height: "20px" }} alt="" />
                        </button>
                        <p className="fs-12 fw-bold text-white mt-2 mb-0">Participate</p>
                      </div>
                    )}

                {(this.state.currentUserTeamPosition === "players" ||
                  this.state.currentUserTeamPosition === "substitutes") && (
                  <div className="col-lg-2 col-md-2 col-4 text-center mb-3">
                    <button
                      className="white-round-btn rounded-circle fw-600 border border-0 btn-size-45"
                      onClick={() => {
                        this.toggelModal("openAcceptInvite");
                      }}
                    >
                      <img src={editInfoIc} style={{ height: "20px" }} alt="" />
                    </button>
                    <p className="fs-12 fw-bold text-white mt-2 mb-0">Edit My Info</p>
                  </div>
                )}

                {(this.state.currentUserClanPosition === "owner" ||
                  this.state.currentUserClanPosition === "admin") && (
                  <div className="col-lg-2 col-md-2 col-4 text-center mb-3">
                    <button
                      className="white-round-btn rounded-circle fw-600 border border-0 btn-size-45"
                      onClick={() => {
                        this.onClickOpenConfirm("delete", this.teamDeleteMsg());
                      }}
                    >
                      <img src={deleteIcon} style={{ height: "20px" }} alt="" />
                    </button>
                    <p className="fs-12 fw-bold text-white mt-2 mb-0">Delete Team</p>
                  </div>
                )}

                {(this.state.currentUserClanPosition === "owner" ||
                  this.state.currentUserClanPosition === "admin") && (
                  <div className="col-lg-2 col-md-2 col-4 text-center mb-3">
                    <button
                      className="white-round-btn rounded-circle fw-600 border border-0 btn-size-45"
                      disabled={
                        !this.state.teamData?.members?.players?.length &&
                        !this.state.teamData?.members?.substitutes?.length
                      }
                      onClick={() => {
                        this.setState({ teamView: 102 });
                      }}
                    >
                      <img src={lineupsIc} style={{ height: "20px" }} alt="" />
                    </button>
                    <p className="fs-12 fw-bold text-white mt-2 mb-0">Line-up</p>
                  </div>
                )}

                {(this.state.currentUserClanPosition === "owner" ||
                  this.state.currentUserClanPosition === "admin") && (
                  <div className="col-lg-2 col-md-2 col-4 text-center mb-3">
                    <button
                      className="white-round-btn rounded-circle fw-600 border border-0 btn-size-45"
                      onClick={() => {
                        this.toggelModal("openClanInvite");
                        this.setState({ inviteAs: "players" });
                      }}
                    >
                      <IoPersonAdd className="fs-20" />
                    </button>
                    <p className="fs-12 fw-bold text-white mt-2 mb-0">Invite</p>
                  </div>
                )}
              </div>

              <div className="row mt-4 mx-1">
                <div className="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-12">
                  <div className="text-center">
                    <img src={instructionIcon} className="" height={"40px"} alt="" />
                  </div>
                  <div className="mt-3">
                    <ul className="ps-0">
                      <li className="fs-12 fw-500 text-start">
                        Team Composition Rules: Each team must have a designated captain and can
                        have a maximum of 3 substitutes alongside the active players.
                      </li>
                      <li className="fs-12 fw-500 text-start">
                        Member Eligibility: All team members must complete their in-game profiles
                        with accurate information and be registered clan members before
                        participating in tournaments.
                      </li>
                      <li className="fs-12 fw-500 text-start">
                        Authority Structure: Only clan owners and administrators have the authority
                        to add, remove, or reassign team members and positions.
                      </li>
                      <li className="fs-12 fw-500 text-start">
                        Tournament Participation: Teams must maintain the minimum required number of
                        active players as specified for each game to remain eligible for tournament
                        registration.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.state.teamView === 102 && (
            <div className="container reAssign-section ps-4 pe-4">
              <IoArrowBackCircleOutline
                className="back-btn"
                onClick={() => {
                  this.setState({ teamView: 101 });
                }}
              />

              <h5 className="mt-5 mb-4 fs-16 fs-lg-20 fw-600">Line-ups</h5>

              <div className="d-flex align-items-center mt-4">
                <h6 className="fs-16 fw-600 text-white mb-1">Players</h6>
                <hr className="mx-2 flex-grow-1 opacity-100" />
              </div>
              <div className="row mt-1 mx-1 justify-content-center">
                {this.state.selectedPlayers.map((el: any, i: any) => {
                  return (
                    <div className="col-12 col-md-6 col-lg-4 mb-3" key={i}>
                      <div className="mulberry-purple-card d-flex align-items-center py-2">
                        <div className="col-8 fw-600 fs-14 text-white text-truncate">
                          <Image
                            src={el?.profilePicture?.url}
                            param={el?.profilePicture?.url ? null : el?.name?.charAt(0)}
                            className="rounded-circle btn-size-32 border border-1 mx-3"
                          />
                          {el?.inGameName}
                        </div>
                        <div className="col-2">
                          {this.state.selectedCaptain?._id === el?._id ? (
                            <AiFillCopyrightCircle className="btn-size-20" />
                          ) : (
                            <BsCircle
                              className="btn-size-20"
                              onClick={() => {
                                this.makeCaptain(el);
                              }}
                            />
                          )}
                        </div>
                        <div className="col-2">
                          <IoIosCloseCircleOutline
                            className="btn-size-20"
                            onClick={() => {
                              this.removeFromPlayers(el, i);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                {!this.state.selectedPlayers?.length && <p>Players not selected</p>}
              </div>

              <div className="d-flex align-items-center mt-4">
                <h6 className="fs-16 fw-600 text-white mb-1">Substitutes</h6>
                <hr className="mx-2 flex-grow-1 opacity-100" />
              </div>
              <div className="row mt-1 mx-1">
                {this.state.selectedSubstitute.map((el: any, i: any) => {
                  return (
                    <div className="col-12 col-md-6 col-lg-4 mb-3" key={i}>
                      <div className="mulberry-purple-card d-flex align-items-center py-2">
                        <div className="col-10 fw-600 fs-14 text-white text-truncate">
                          <Image
                            src={el?.profilePicture?.url}
                            param={el?.profilePicture?.url ? null : el?.name?.charAt(0)}
                            className="rounded-circle btn-size-32 border border-1 mx-3"
                          />
                          {el?.inGameName}
                        </div>
                        <div className="col-2">
                          <IoIosCloseCircleOutline
                            className="btn-size-20"
                            onClick={() => {
                              this.removeFromSubstitute(el, i);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                {!this.state.selectedSubstitute?.length && <p>Substitute not selected</p>}
              </div>
              <div className="">
                <button
                  className="white-flat-btn d-block fs-14 fw-600 py-2 px-5 m-auto mt-3 mb-2"
                  onClick={this.teamShuffle}
                >
                  Save
                </button>
              </div>

              <div className="row mt-4 mx-1">
                <div className="col-12">
                  <div className="text-center">
                    <img src={instructionIcon} className="" height={"40px"} alt="" />
                  </div>
                  <div className="mt-3">
                    <ul className="ps-0">
                      <li className="fs-12 fw-500 text-start">
                        Team Composition Rules: Each team must have a designated captain and can
                        have a maximum of 3 substitutes alongside the active players.
                      </li>
                      <li className="fs-12 fw-500 text-start">
                        Member Eligibility: All team members must complete their in-game profiles
                        with accurate information and be registered clan members before
                        participating in tournaments.
                      </li>
                      <li className="fs-12 fw-500 text-start">
                        Authority Structure: Only clan owners and administrators have the authority
                        to add, remove, or reassign team members and positions.
                      </li>
                      <li className="fs-12 fw-500 text-start">
                        Tournament Participation: Teams must maintain the minimum required number of
                        active players as specified for each game to remain eligible for tournament
                        registration.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>

        <Modal show={openAddMember} centered dialogClassName="AddMember-modal">
          <Modal.Body>
            <AddMember onClick={this.toggelModal} />
          </Modal.Body>
        </Modal>
        <Modal show={openAssignMember} centered dialogClassName="AssignMember-modal">
          <Modal.Body>
            <AssignMember onClick={this.toggelModal} />
          </Modal.Body>
        </Modal>
        <Modal show={openClanInvite} centered dialogClassName="ClanInvite-modal">
          <Modal.Body>
            <ClanInvite
              onClick={this.toggelModal}
              inviteType="team"
              inviteAs={this.state.inviteAs}
              teamId={this.state.teamId}
              name={this.state.teamData?.name}
            />
          </Modal.Body>
        </Modal>
        <Modal show={openAcceptInvite} centered dialogClassName="accept-invite-modal">
          <Modal.Body>
            <AcceptInviteV2
              updateLoader={this.props.updateLoader}
              title="Update Team Profile"
              close={this.toggelModal}
              bioChange={this.bioChange}
              type="update"
              joinTeamRole={null}
              info={this.state.inGameInfo}
              role={this.state.participantRole}
              isTournamentInvitation={false}
            />
          </Modal.Body>
        </Modal>
        <Modal show={openShowMember} centered dialogClassName="ShowMember-modal">
          <Modal.Body>
            <ShowMember
              members={this.state.showClanMember}
              onClickOpenShowMember={this.onClickOpenShowMember}
            />
          </Modal.Body>
        </Modal>
        <Modal show={this.state.openConfirm} centered dialogClassName="Confirmation-modal">
          <Modal.Body>
            <ConfirmationModal
              confirm={this.state.confirm}
              onClickOpenConfirm={this.onClickOpenConfirm}
              confirmed={this.confirmed}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.participateInTeam}
          centered
          dialogClassName="teamView-participate-modal"
        >
          <Modal.Body>
            <div className="p-3">
              <IoIosCloseCircleOutline
                className="close-icon position-absolute"
                style={{ right: "15px", top: "15px" }}
                onClick={() => this.participateInTeam(false)}
              />
              <p className="fw-bold fs-20 text-center text-white mb-0">Participate</p>
              <div id="invite-section">
                <p className="fs-14 fw-600 text-center text-white-50 mt-4 mb-1">
                  Please select your role in team
                </p>
                <Dropdown className="mb-2 select-game-dropdown ">
                  <Dropdown.Toggle className="dropdown-basic text-start w-100 height-45">
                    {capitalize(this.state.participantRole)}
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    onClick={(e: React.MouseEvent<HTMLElement>) => {
                      const target = e.target as HTMLElement;
                      const dropdownItem = target.closest(".dropdown-item");
                      if (dropdownItem) {
                        const role = dropdownItem.getAttribute("data-name");
                        if (role) {
                          this.setState({ participantRole: role });
                        }
                      }
                    }}
                  >
                    {this.state.teamMembers.map((role: string, index: number) => (
                      <Dropdown.Item
                        key={index}
                        href="#"
                        className="text-white fs-14 fw-500"
                        data-name={role}
                        onClick={(e: React.MouseEvent) => e.preventDefault()}
                      >
                        {ellipsis(capitalize(role), 25)}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
                <button
                  className="white-flat-btn d-block fw-bold py-2 px-4 m-auto mt-3 mb-2"
                  type="submit"
                  onClick={this.joinTeam}
                >
                  Continue
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.previewImageDetails.display}
          centered
          dialogClassName="image-preview-container bg-transparent"
        >
          <ImagePreview
            previewImageDetails={this.state.previewImageDetails}
            previewImage={this.previewImage}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  teamData: state.team.teamData,
});

const mapDispatchToProps = (dispatch: any) => ({
  setTeamData: (teamData: any) => dispatch(setTeamData(teamData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamViewV2);
